<form [formGroup]="formGroup" name="registerDeviceForm" novalidate>
  <div class="{{ className }}__form-field-wrapper {{ className }}__container-flex">
    <input
      #zipInput
      (change)="fileChangeEvent($event)"
      accept=".zip"
      style="display: none"
      id="zip-input"
      type="file" />
    <div class="{{ className }}__group-input-button" *ngIf="formGroup.controls.file.value === null">
      <button
        (click)="zipInput.click()"
        color="purple"
        id="input-file"
        mat-fab
        class="{{ theme }} {{ className }}__category-button">
        <mat-icon class="material-icons-sharp {{ className }}__icon">upload</mat-icon>
        {{ labels.newVersion | uppercase }}
      </button>
      <!--      <button-->
      <!--        (click)="zipInput.click()"-->
      <!--        class="{{theme}} {{ className }}__button"-->
      <!--        color="primary"-->
      <!--        mat-mini-fab>-->
      <!--        <mat-icon class="material-icons-sharp {{theme}} {{ className }}__icon">upload</mat-icon>-->
      <!--      </button>-->
      <span (click)="zipInput.click()" class="{{ className }}__button-label">{{
        labels.buttonUpload | uppercase
      }}</span>
    </div>

    <div class="{{ className }}__group-input-button" *ngIf="formGroup.controls.file.value !== null">
      <button
        (click)="deleteAppVersionFile()"
        class="{{ className }}__button-delete"
        color="purple"
        id="delete-version-file"
        mat-fab>
        <mat-icon class="material-icons-sharp {{ className }}__icon">close</mat-icon>
      </button>
      <span
        class="{{ className }}__text-file"
        matTooltip="{{ formGroup.controls.version.value }}"
        matTooltipClass="custom-tooltip"
        matTooltipPosition="above"
        >{{ formGroup.controls.version.value }}</span
      >
    </div>
    <div class="{{ className }}__group-input">
      <span class="{{ theme }} {{ className }}__form-field-label">Version name</span>
      <mat-form-field
        [ngClass]="formGroup.controls.file.value !== null ? 'input-reduce' : ''"
        appearance="outline">
        <input
          #versionName
          formControlName="versionName"
          matInput
          id="name-version"
          maxlength="16"
          name="versionName"
          placeholder="{{ labels.namePlaceholder }}" />
        <mat-hint align="end">{{ versionName.value.length }} / 16</mat-hint>
      </mat-form-field>
    </div>
  </div>
</form>
